import { useEffect, useState } from "react";

import { useHistory, useLocation } from "react-router-dom";
import EventListItem from "../models/item.interface";
import EventListState from "../models/state.interface";
import fetchContentByType from "app/umbraco/helpers/fetchContentByType";
import moment from "moment";

export default (): any => {
    const history = useHistory();
    const location = useLocation<EventListState>();

    const initialItems = location.state?.posts;
    const [items, setItems] = useState<EventListItem[]>(initialItems);

    const [filteredItems, setFilteredItems] = useState<EventListItem[]>([]);
    const [currentFilter, setCurrentFilter] = useState<string>("UPCOMING");

    const [viewState, setViewState] = useState<string>(initialItems?.length > 0 ? "LOADED" : "LOADING");

    useEffect(() => {
        let isComponentMounted = true;

        const fetchEvents = async () => {
            let result: EventListItem[] = [];
            const response = await fetchContentByType<EventListItem[]>("eventPage", history.location.pathname);

            if (response && response.length > 0) {
                result = response;
            }

            if (isComponentMounted) {
                setItems(result);
                return result;
            }
        };

        fetchEvents().then((result: any) => {
            if (result && result.length > 0) {
                setViewState("LOADED");
            }
            else {
                setViewState("EMPTY");
            }
        }).catch(() => {
            setViewState("ERROR");
        });

        return () => {
            isComponentMounted = false;
        };
    }, []);

    useEffect(() => {
        if (items && items.length > 0) {
            // Filter only matching currentFilter
            const eligibleItems = items.filter(item => {
                const endDate = moment(item.eventDateEnd, "YYYY-MM-DDTHH:mm:ss");
                const nowDate = moment();

                if (currentFilter === "UPCOMING") {
                    return endDate.isSameOrAfter(nowDate);
                }
                else {
                    return endDate.isSameOrBefore(nowDate);
                }
            });

            // Sort by date asc
            const sortedItems = eligibleItems.sort((a: EventListItem, b: EventListItem) => {
                const aDate = moment(a.eventDateStart, "YYYY-MM-DDTHH:mm:ss");
                const bDate = moment(b.eventDateStart, "YYYY-MM-DDTHH:mm:ss");

                if (currentFilter === "UPCOMING") {
                    return aDate.diff(bDate);
                }
                else {
                    return bDate.diff(aDate);
                }
            });

            history.replace({
                pathname: location.pathname,
                search: location.search,
                hash: location.hash,
                state: {
                    ...location.state,
                    posts: sortedItems
                }
            });

            setFilteredItems(sortedItems);
        }

    }, [items, currentFilter]);

    return { filteredItems, viewState, currentFilter, setCurrentFilter };
};